import {
  emptyCreatedDateFilter,
  hasCreatedDateFilter,
  type CreatedDateFilterState,
} from "@sd/lib/ticketCreatedDateFilter";
import { normalizeMultiFilterValues } from "@sd/lib/ticketFilterApi";

export const DEFAULT_TICKET_FILTER_TYPE = "all";
export const DEFAULT_MODULE_FILTER = "all";

export function hasActiveTicketFilters(input: {
  search: string;
  statusFilters: string[];
  priorityFilters?: string[];
  categoryFilters?: string[];
  typeFilter?: string;
  projectFilters?: string[];
  assigneeFilters?: string[];
  requesterFilters?: string[];
  createdDateFilter?: CreatedDateFilterState;
  moduleFilter?: string;
}): boolean {
  return (
    input.search.trim() !== "" ||
    normalizeMultiFilterValues(input.statusFilters).length > 0 ||
    normalizeMultiFilterValues(input.priorityFilters ?? []).length > 0 ||
    normalizeMultiFilterValues(input.categoryFilters ?? []).length > 0 ||
    (input.typeFilter !== undefined &&
      input.typeFilter !== DEFAULT_TICKET_FILTER_TYPE) ||
    normalizeMultiFilterValues(input.projectFilters ?? []).length > 0 ||
    normalizeMultiFilterValues(input.assigneeFilters ?? []).length > 0 ||
    normalizeMultiFilterValues(input.requesterFilters ?? []).length > 0 ||
    (input.createdDateFilter !== undefined &&
      hasCreatedDateFilter(input.createdDateFilter)) ||
    (input.moduleFilter !== undefined &&
      input.moduleFilter !== DEFAULT_MODULE_FILTER)
  );
}

export function emptyTicketFilterState() {
  return {
    search: "",
    statusFilters: [] as string[],
    priorityFilters: [] as string[],
    categoryFilters: [] as string[],
    typeFilter: DEFAULT_TICKET_FILTER_TYPE,
    projectFilters: [] as string[],
    assigneeFilters: [] as string[],
    requesterFilters: [] as string[],
    createdDateFilter: emptyCreatedDateFilter(),
    moduleFilter: DEFAULT_MODULE_FILTER,
  };
}
